module.exports = __webpack_public_path__ + "media/pro/mark-as-rented@2x-75f25940.png";